import React from "react";
import Uploader from "../../uploader";
import { Input, InputNumber, Radio } from "antd";
import AskWizardMultichoice from "./multichoice";
import { VaporDatePicker } from "../../../vapor";
import { FormattedMessage } from "react-intl";

const AskWizardWidget = (props) => {
  const { numQuestion, tmpDetail, values, setValues } = props;

  if (tmpDetail.items && tmpDetail.items[numQuestion - 1]) {
    switch (tmpDetail.items[numQuestion - 1].type) {
    case "input":
      switch (tmpDetail.items[numQuestion - 1].format) {
      case "date":
        return (
          <VaporDatePicker
            getPopupContainer={(trigger) => trigger.parentNode}
            value={values["askWizard-item-field_" + numQuestion]}
            className="askWizard-widget-inputDate"
            onChange={(value) =>
              setValues({
                ...values,
                ["askWizard-item-field_" + numQuestion]: value
              })
            }
          />
        );
      case "number":
        return (
          <InputNumber
            size="large"
            type="number"
            name={"askWizard-item-field_" + numQuestion}
            value={values["askWizard-item-field_" + numQuestion]}
            className="askWizard-widget-inputNumber"
            onChange={(value) =>
              setValues({
                ...values,
                ["askWizard-item-field_" + numQuestion]: value
              })
            }
          />
        );
      case "currency":
        return (
          <InputNumber
            size="large"
            name={"askWizard-item-field_" + numQuestion}
            value={values["askWizard-item-field_" + numQuestion]}
            className="askWizard-widget-inputNumber"
            onChange={(value) =>
              setValues({
                ...values,
                ["askWizard-item-field_" + numQuestion]: value
              })
            }
            formatter={(value) => `${value ? "€ " : ""}${value}`.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
            parser={(value) => value.replace(/€\s?|(\.*)/g, "").replace(",", ".")}
          />
        );
      default:
        return (
          <Input
            name={"askWizard-item-field_" + numQuestion}
            value={values["askWizard-item-field_" + numQuestion]}
            className="askWizard-widget-input"
            onChange={(e) =>
              setValues({
                ...values,
                ["askWizard-item-field_" + numQuestion]: e.target.value
              })
            }
          />
        );
      }
    case "boolean":
      return (
        <Radio.Group
          name={"askWizard-item-field_" + numQuestion}
          value={
            values["askWizard-item-field_" + numQuestion] === "true"
              ? "yes"
              : values["askWizard-item-field_" + numQuestion] === "false"
                ? "no"
                : values["askWizard-item-field_" + numQuestion]
                  ? values["askWizard-item-field_" + numQuestion]
                  : null
          }
          onChange={(e) =>
            setValues({
              ...values,
              ["askWizard-item-field_" + numQuestion]: e.target.value === "yes" ? "true" : "false"
            })
          }
        >
          <Radio value={"yes"}><FormattedMessage id="generic.yes" /></Radio>
          <Radio value={"no"}><FormattedMessage id="generic.no" /></Radio>
        </Radio.Group>
      );
    case "radio":
    case "checkbox":
      return <AskWizardMultichoice item={tmpDetail.items[numQuestion - 1]} values={values} numQuestion={numQuestion} setValues={(val) => setValues(val)} />;
    case "file":
      return (
        <div>
          <Uploader
            numQuestion={numQuestion}
            filesFromValues={values["askWizard-item-field_" + numQuestion] || []}
            onUpload={(filesArr) => {
              setValues({
                ...values,
                ["askWizard-item-field_" + numQuestion]: filesArr[numQuestion]
              });
            }}
            required={tmpDetail.items[numQuestion - 1].required}
            questionDesc={tmpDetail.items[numQuestion - 1].label}
          />
        </div>
      );
    default:
      return <div></div>;
    }
  }
  return <div></div>;
};

export default AskWizardWidget;
